import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import {
  IRecurringInvoice,
  IRecurringInvoiceUpsertPayload,
} from "./RecurringInvoice.types";

export const FETCH_RECURRING_INVOICES_LIST_PROGRESS =
  "FETCH_RECURRING_INVOICES_LIST_PROGRESS";
export const FETCH_RECURRING_INVOICES_LIST_SUCCESS =
  "FETCH_RECURRING_INVOICES_LIST_SUCCESS";
export const FETCH_RECURRING_INVOICES_LIST_FAILED =
  "FETCH_RECURRING_INVOICES_LIST_FAILED";
export const FETCH_RECURRING_INVOICE_PROGRESS =
  "FETCH_RECURRING_INVOICE_PROGRESS";
export const FETCH_RECURRING_INVOICE_SUCCESS =
  "FETCH_RECURRING_INVOICE_SUCCESS";
export const FETCH_RECURRING_INVOICE_FAILED =
  "FETCH_RECURRING_INVOICE_FAILED";
export const CLEAR_RECURRING_INVOICE_STATE = "CLEAR_RECURRING_INVOICE_STATE";

export const fetchRecurringInvoicesListProgress = () =>
  action(FETCH_RECURRING_INVOICES_LIST_PROGRESS);

export const fetchRecurringInvoicesListSuccess = (
  data: IRecurringInvoice[],
  totalRecords: number
) => action(FETCH_RECURRING_INVOICES_LIST_SUCCESS, { data, totalRecords });

export const fetchRecurringInvoicesListFailed = (errorMessage: string) =>
  action(FETCH_RECURRING_INVOICES_LIST_FAILED, { errorMessage });

export const fetchRecurringInvoiceProgress = () =>
  action(FETCH_RECURRING_INVOICE_PROGRESS);

export const fetchRecurringInvoiceSuccess = (data: IRecurringInvoice) =>
  action(FETCH_RECURRING_INVOICE_SUCCESS, { data });

export const fetchRecurringInvoiceFailed = (errorMessage: string) =>
  action(FETCH_RECURRING_INVOICE_FAILED, { errorMessage });

export const fetchRecurringInvoicesListAsync =
  (frequency?: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchRecurringInvoicesListProgress());

      let url = `/accounting/get-recurring-invoices`;
      if (frequency) {
        url += `?frequency=${frequency}`;
      }

      const res = await api.get(url);
      const data: IRecurringInvoice[] = res.data.data;
      const totalRecords: number = res.data.totalRecords;
      dispatch(fetchRecurringInvoicesListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(
        fetchRecurringInvoicesListFailed("Something went to be wrong!")
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchRecurringInvoiceByIdAsync =
  (recurringInvoiceId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchRecurringInvoiceProgress());
      const res = await api.get(
        `/accounting/get-recurring-invoices?accn_recurring_invoices_id=${recurringInvoiceId}`
      );
      const list: IRecurringInvoice[] = res.data.data;
      if (list.length > 0) {
        dispatch(fetchRecurringInvoiceSuccess(list[0]));
      } else {
        dispatch(fetchRecurringInvoiceFailed("Recurring invoice not found."));
      }
    } catch (err: any) {
      dispatch(fetchRecurringInvoiceFailed("Something went wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertRecurringInvoiceAsync =
  (
    data: IRecurringInvoiceUpsertPayload,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/accounting/upsert-recurring-invoice", {
        ...data,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Recurring invoice saved successfully.",
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const clearRecurringInvoiceState = () =>
  action(CLEAR_RECURRING_INVOICE_STATE);
